module.exports = __webpack_public_path__ + "img/wrapbg2.a646fa2e.png";